const firebaseConfig = {
    apiKey: "AIzaSyCQWfUEQ4kw3haFguOSlpJKyzezCW4JoYI",
    authDomain: "cypher-s-lab.firebaseapp.com",
    projectId: "cypher-s-lab",
    storageBucket: "cypher-s-lab.appspot.com",
    messagingSenderId: "1010847128415",
    appId: "1:1010847128415:web:5d331ee1adbe172d9a34ea"
  };

  export default firebaseConfig;